module.exports = __webpack_public_path__ + "img/cattle_grid.0c9036cf.svg";